import {featuresActionTypes} from './features.types';
export const setUserFeatures = features => ({
    type : featuresActionTypes.SET_USER_FEATURES,
    payload : features
})